import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useNavigate } from 'react-router-dom';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import AddAttendPopup from "../popup/add_attend";
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import strFunc from "@/lib/lyg/string";
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import AttendCalendarArea from "./area/calendar";

function AttendMain() {
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const left_box_scroll_ref = useRef<any>(null);
  const right_cal_ref = useRef<any>(null);
  const AttendCalendarAreaRef = useRef<any>(null);
  const FindStudentListRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState<any>({
    s_grade: "student",
    s_stu_state: "now",
    s_search_text_type: "a_user_name",
    s_search_text: "",
    s_user_name_like: "",
    s_school_name_like: "",
    s_addon_class_user: "1",
    s_addon_link_user: "1",
    //s_addon_profile:"1",
    s_addon_attend: "1",
    s_addon_attend_start_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    s_addon_attend_end_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    s_stu_lecture_seq: "",//user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
  });

  const [select_stu_info_arr, set_select_stu_info_arr] = useState<any>([]);
  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "add_attend",
    attend_sort: "in",//in,out
    attend_sort_detail: "",
    attend_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    userInfoArr: [],
    title: "팝업",
    width: "450px",
    height: "60%",
  });
  let is_under_width = MyScreenFunc.get_is_under();

  useEffect(() => {

  }, []);

  const openAttendPopup = (attend_sort: string, attend_sort_detail: string, select_user: any) => {
    let pop_title = "등원";
    if (attend_sort == "out") {
      pop_title = "하원";
    }
    if (xColumnArr.select_arr.a_sort_detail) {
      for (let i = 0; i < xColumnArr.select_arr.a_sort_detail.length; i++) {
        let item = xColumnArr.select_arr.a_sort_detail[i];
        if (item.value == attend_sort_detail) {
          pop_title = item.text;
        }
      }
    }
    let selected_row = FindStudentListRef.current.get_select_arr();
    if (!strFunc.is_empty(select_user)) {
      selected_row = [select_user];
    }
    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    let attend_date = listOpt.s_addon_attend_start_date;
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      attend_sort: attend_sort,
      attend_sort_detail: attend_sort_detail,
      attend_date: attend_date,
      userInfoArr: selected_row,
    });
  };

  const go_search_calendar_stu = (inData: any) => {
    let opt_obj = {
      selected_row: [],
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    let tmp_stu_seq_arr = [];
    for (let i = 0; i < selected_row.length; i++) {
      tmp_stu_seq_arr.push(selected_row[i]["a_seq"]);
    }
    AttendCalendarAreaRef.current.setInitData({
      "stu_seq_arr": tmp_stu_seq_arr,
    });
  };

  return (
    <CompLayout isLeftArea={true} isConTitle={false}>
      <SearchArea
        listOpt={listOpt}
        setListOpt={(inData: any) => {
          setListOpt({ ...listOpt, ...inData });
          if (FindStudentListRef.current) {
            FindStudentListRef.current.setListOpt(inData);
          }
        }}
        show_search_key_arr={[
          "s_user_name_like",
          "s_school_name_like",
          "s_stu_lecture_seq",
          "s_stu_grade",
          "s_attend_sort_detail",
          "s_stu_state",
        ]}
        list={(inData: any) => {
          if (FindStudentListRef.current) {
            FindStudentListRef.current.list(inData);
          }
        }}
      ></SearchArea>
      <table style={{ width: "100%" }}>
        <colgroup>
          <col width={"540px"} />
          <col width={"*"} />
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "540px" }}>
                <div ref={left_box_scroll_ref}>
                  <div className="mt-1" style={{ lineHeight: "36px", position: "relative" }}>
                    <button className="btn-m btn-line-yellowish2" onClick={() => { openAttendPopup("in", "in", null); }} >
                      <span className="ml-1">일괄처리</span>
                    </button>
                    <span>
                      <span className="main_text_color  ml-2">{select_stu_info_arr.length}</span>명 선택됨
                    </span>
                    <span style={{ position: "absolute", right: 0 }}>
                      {listOpt.s_addon_attend_start_date}
                      <select className="search-input ml-1" name="s_grade" value={listOpt.s_grade}
                        onChange={(e: any) => {
                          let value = e.target.value;
                          if (FindStudentListRef.current) {
                            let change_list_opt: any = {
                              s_grade: value,
                            };
                            if (value == "student") {
                              change_list_opt["s_stu_state"] = "now";
                            } else {
                              change_list_opt["s_stu_state"] = "";
                            }
                            FindStudentListRef.current.list({ now_page: "1", ...change_list_opt });
                          }
                        }}>
                        <option value={"student"}>학생</option>
                        <option value={"teacher"}>선생님</option>
                        <option value={"staff"}>직원</option>
                        <option value={"master"}>관리자</option>
                      </select>
                    </span>
                  </div>
                  <FindStudentList
                    ref={FindStudentListRef}
                    listOpt={listOpt}
                    show_key_arr={["row_view_attend", "row_view_attend_in_memo"]}
                    on_search_list={(inData: any) => {
                      setListOpt({ ...listOpt, ...inData });
                    }}
                    list={(inData: any) => {
                      go_search_calendar_stu({
                        selected_row: inData.select_stu_info_arr
                      });
                      set_select_stu_info_arr(inData.select_stu_info_arr);
                    }}
                    grid_opt={{
                      height: window.innerHeight - 224,
                      domLayout: "normal",
                    }}
                    is_use_paging={false}
                    is_show_search_area={false}
                    is_show_title={false}
                  ></FindStudentList>
                </div>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "730px", paddingLeft: "10px" }}>
                <div ref={right_cal_ref}>
                  <AttendCalendarArea
                    ref={AttendCalendarAreaRef}
                    select_date={listOpt.s_addon_attend_start_date}
                    set_select_date={(inData: any) => {
                      AttendCalendarAreaRef.current.setInitData({
                        "select_date": inData,
                      });
                      if (FindStudentListRef.current) {
                        let select_seq_arr: any = [];
                        for (let i = 0; i < select_stu_info_arr.length; i++) {
                          select_seq_arr.push(select_stu_info_arr[i]["a_seq"]);
                        }

                        FindStudentListRef.current.list({
                          "s_addon_attend_start_date": inData,
                          "s_addon_attend_end_date": inData,
                          "select_seq_arr": select_seq_arr
                        });
                      }
                    }}
                  ></AttendCalendarArea>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <RightScrollFix
        right_ref={left_box_scroll_ref}
        limit_scroll_top={290}
      ></RightScrollFix>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "add_attend" &&
            <AddAttendPopup attend_sort={popupData.attend_sort} attend_sort_detail={popupData.attend_sort_detail}
              attend_date={popupData.attend_date}
              userInfoArr={popupData.userInfoArr}
              callback={() => {
                if (FindStudentListRef.current) {
                  FindStudentListRef.current.list({});
                }
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></AddAttendPopup>
          }
        </LayerPopup>
      }
    </CompLayout>
  );
}

export default AttendMain;